
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns:i":"&ns_ai;","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","id":"Layer_1","x":"0","y":"0","viewBox":"0 0 156 180","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('switch',{attrs:{"id":"switch16"}},[_c('foreignObject',{attrs:{"requiredExtensions":"http://ns.adobe.com/AdobeIllustrator/10.0/","x":"0","y":"0","width":"1","height":"1"}},[_c('i:pgfRef',{attrs:{"xlink:href":"#adobe_illustrator_pgf"}})]),_c('g',{attrs:{"i:extraneous":"self","id":"g14"}},[_c('g',{attrs:{"id":"g12"}},[_c('path',{attrs:{"d":"M38.5 43.1C55.5 34 79.9 56.9 80 57V37.6c-1.9-1.1-62.7-37.8-69-22C.1 42.6 38.5 173 57.9 175.8c14.2 2 22.2-16.5 22.2-16.5v-13.7c-29.7 0-66.4-89.2-41.6-102.5z","id":"path4","fill":"#2bb8c9"}}),_c('path',{attrs:{"d":"M149.1 15.5C142.6-.4 80 37.6 80 37.6V57c1.2-1.3 22.9-24.4 40.2-15.9 31.4 15.4-11 104.4-40.2 104.5l.1 13.7s7.8 18.4 22.1 16.3C121.6 173 160 42.5 149.1 15.5z","id":"path6","fill":"#95c11f"}}),_c('path',{staticClass:"st2",attrs:{"d":"M80 145.6s0-.1 0 0v-31.7 31.7z","id":"path8"}}),_c('path',{staticClass:"st2",attrs:{"d":"M80 57v56.8V57s0 .1 0 0c0 .1 0 .1 0 0z","id":"path10"}})])])]),_c('i:pgf',{attrs:{"id":"adobe_illustrator_pgf"}})])
          )
        }
      }
    